import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const EditCapexLink = styled(({ capex, children, farmId, className }) => {
  const { farmId: paramsFarmId } = useParams();
  return (
    <Link
      to={`/app/farm/${farmId || paramsFarmId}/data/capexes/${capex.id}/edit`}
      className={className}
    >
      {children}
    </Link>
  );
})`
  color: var(--text-color);

  &:hover {
    text-decoration: underline;
  }
`;

export default EditCapexLink;
